import { render, staticRenderFns } from "./redpacket_category_edit.vue?vue&type=template&id=18303da8&scoped=true"
import script from "./redpacket_category_edit.vue?vue&type=script&lang=ts"
export * from "./redpacket_category_edit.vue?vue&type=script&lang=ts"
import style0 from "./redpacket_category_edit.vue?vue&type=style&index=0&id=18303da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18303da8",
  null
  
)

export default component.exports